import React from 'react';
import {Header,Item, Label,  Breadcrumb, Embed, Transition, Icon, Segment,Container, Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import Quiz from 'react-quiz-component';
import moment from 'moment';


 //<Quiz quiz={quiz} showInstantFeedback={true} continueTillCorrect={true} onComplete={setQuizResult} showDefaultResult={false} customResultPage={renderCustomResultPage}/>
/*

showDefaultResult={false} customResultPage={renderCustomResultPage}

*/


const Examen=({ id, ajaxCallInProgress, errores=[], strings,  quiz, setQuizResult, renderCustomResultPage})=>{

   
	return (

     <div>
            <Header as='h3'>{strings?strings["preVisualizacion"]:""}</Header>
            
            {errores.length>0?
        
                <Segment style={{width: '100%', height:'80%'}}>
                    <Header as='h3'>{strings?strings["preguntasError"]:""}</Header>
                 {errores.map(row=>
                
                    <p>
                    {row.question}
                    </p>
        
                )}
        
                </Segment>
            :
                <div>
                    {quiz!=null?
                        <Quiz quiz={quiz}  showInstantFeedback={true} continueTillCorrect={true} onComplete={setQuizResult} showDefaultResult={true} shuffle={true}/>
                    :
                        ""
                    }    
                 </div>
        }
        
        </div>

	);
};



export default Examen;